var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLeftPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 134 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.733 8.438c2.826 5.267 2.49 18.628-1.162 19.569-1.457.375-4.56-.544-7.717-2.448l1.982 14.023H54.132l4.03-18.78c-2.248-2.637-3.768-5.87-3.514-9.491.732-10.436 15.26-8.14 18.085-2.873z",
    fill: "#B28B67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.018 22.582c-1.469-6.535-5.654-10.99-5.015-13.91.426-1.948 1.562-3.159 3.407-3.634.955-3.86 4.032-5.502 9.234-4.926 7.801.865 12.563 4.105 10.507 11.235-1.89 0-4.172-.684-7.328.487-1.001.372-1.717 1.524-2.148 3.458h-1.426c-1.384-2.295-2.749-3.138-4.094-2.53-1.345.609-1.651 2.086-.918 4.432l-.702 5.388h-1.517z",
    fill: "#2C0606"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.985 81.668l17.276 64.017 8.126 48.065h8.156L84.4 81.668H58.985z",
    fill: "#997659"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3 81.668c1.153 32.958.698 50.935.44 53.929-.257 2.995-1.721 23.049-11.698 58.153h8.108c13.213-33.676 17.825-53.731 19.34-58.153 1.516-4.422 5.991-22.398 12.525-53.929H49.301z",
    fill: "#B28B67"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.116 81.668c4.702 21.541 12.835 55.926 24.398 103.155h12.482c.922-48.476-3-80.381-9.791-103.155H57.116z",
    fill: "#552730"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.316 81.668c1.236 32.521-1.966 64.56-11.883 103.662h13.318c14.49-32.734 24.875-64.615 31.973-103.662H49.316z",
    fill: "#5E333A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.105 192.973c-.548 1.474-.822 2.576-.822 3.309 0 .894.148 2.199.445 3.915h27.834c.723-2.403.306-3.7-1.253-3.892a157.215 157.215 0 01-3.883-.519l-12.929-5.792a.502.502 0 00-.669.268L45 192.281c-1.443.677-2.615 1.015-3.517 1.015-.73 0-1.736-.295-3.019-.884a1.003 1.003 0 00-1.359.561zM83.495 192.973c-.548 1.474-.822 2.576-.822 3.309 0 .894.148 2.199.445 3.915h27.834c.723-2.403.306-3.7-1.253-3.892a157.49 157.49 0 01-3.883-.519l-12.928-5.792a.502.502 0 00-.67.268l-.828 2.019c-1.443.677-2.615 1.015-3.517 1.015-.73 0-1.736-.295-3.019-.884a1.003 1.003 0 00-1.359.561z",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.854 76.36l10.295.59c-7.049 19.262-11.008 29.932-11.876 32.009l-.051.12-.06.137c-1.287 2.777.903 7.228 1.815 9.606-3.438 1.331-2.792-4.243-7.133-2.488-.823.332-1.609.73-2.376 1.125l-.417.215c-2.77 1.423-5.344 2.643-8.61.372-.532-.37-1.068-1.684.439-2.609 3.754-2.304 9.204-6.395 9.984-7.796 1.063-1.911 3.727-12.338 7.99-31.281zm96.927-29.02l-.113.231-.225.463c-1.114 2.317-2.045 4.625-1.37 5.28.743.722 2.44-.428 3.345.788.604.81-2.321 2.293-8.773 4.447L105.819 70.63l-6.677-6.485 16.609-10.304c2.666-3.542 5.329-6.324 7.991-8.346.825-.397 2.289-.688 1.039 1.844z",
    fill: "#B28B67"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.795 33.475l4.123-1.322C74.384 39.832 81.17 60.86 87.704 62.852c6.179 1.883 14.033-1.883 23.31-6.782l3.937 6.299c-7.523 10.901-25.292 21.715-33.613 18.137-13.305-5.721-19.871-31.91-21.543-47.031z",
    fill: "#2D4053"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.874 89.432l37.39-5.255c1.71-.24 1.04-2.674.616-3.89C82 66.247 68.686 52.246 65.797 31.693l-11.024-.184c-6.894 15.672-7.485 33.858-5.899 57.922z",
    fill: "#3C6083"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.347 31.008c14.344 31.807 20.12 53.532 17.326 65.174l-33.658 4.731c-.602-8.148-.094-16.926 1.075-25.58-5.68 14.89-10.69 25.74-15.027 32.549l-8.054-.442c.626-32.174 11.982-57.451 34.068-75.832l4.27-.6z",
    fill: "#2D4053"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.198 21.453l-12.08-3.92-3.017 9.3 2.78.902c5.135 1.666 10.65-1.146 12.317-6.282z",
    fill: "#C4C4C4"
  })));
}
export default SvgImgLeftPerson;